// @ts-nocheck
import React, { FC } from 'react';

import { Container, Row, Col } from 'crehana-ui/GridV2';
import { useTranslation } from '@crehana/i18n';

import { useMe } from 'Jsx/ContextApis/AuthContext';

import { Landing, TKeys } from 'Jsx/CouponLanding/types';

import ImageAdornment from './ImageAdornment';
import CouponAuthForm from './CouponAuthForm';

interface HeroProps
  extends Pick<
    Landing,
    'title' | 'description' | 'promoImageUrl' | 'itemType'
  > {
  landingId: string;
  buttonLabel: string;
  nextUrl: string;
  couponCode: string;
  itemId: number;
}

const Hero: FC<HeroProps> = ({
  landingId,
  title,
  description,
  promoImageUrl,
  buttonLabel,
  nextUrl,
  couponCode,
  itemId,
  itemType,
}) => {
  const { me } = useMe();
  const { t } = useTranslation<TKeys>();

  return (
    <section className="relative text-white pt-52 md:pt-72">
      <div className="absolute inset-y-0 left-0 w-full bg-base-dark sm:w-2/3" />

      <Container className="relative pt-8 pb-24 sm:pt-20 lg:pt-24 sm:pb-32 lg:pb-48">
        <Row>
          <Col sm={6}>
            <Row totalCols={{ sm: 6 }} className="mb-4">
              <Col sm={6} md={6} lg={5}>
                <h1 className="text-center whitespace-pre-line font-h3-md sm:text-justify">
                  {!me ? title : t('HERO_TITLE_SORRY')}
                </h1>
              </Col>
            </Row>

            {description ? (
              <Row totalCols={{ sm: 6 }} className="mb-12">
                <Col sm={5} lg={4}>
                  <h2 className="text-center font-body2 sm:text-justify">
                    {!me ? description : t('HERO_DESCRIPTION_SORRY')}
                  </h2>
                </Col>
              </Row>
            ) : null}

            {promoImageUrl ? (
              <Row totalCols={{ sm: 6 }} className="mb-12 sm:hidden">
                <Col xs={10} sm={5} lg={4} offset={{ xs: 1, sm: 0 }}>
                  <ImageAdornment src={promoImageUrl} />
                </Col>
              </Row>
            ) : null}

            <Row totalCols={{ sm: 6 }} className="mb-12">
              <Col sm={5} lg={4}>
                <CouponAuthForm
                  landingId={landingId}
                  buttonLabel={buttonLabel}
                  nextUrl={nextUrl}
                  promoImageUrl={promoImageUrl}
                  couponCode={couponCode}
                  itemId={itemId}
                  itemType={itemType}
                />
              </Col>
            </Row>
          </Col>

          {promoImageUrl ? (
            <Col sm={6} className="hidden sm:block">
              <ImageAdornment src={promoImageUrl} />
            </Col>
          ) : null}
        </Row>
      </Container>
    </section>
  );
};

export default Hero;
